let sortAddedServices = services => _.sortBy(services, service =>
    _.isString(service.id)
        ? parseInt(service.id.replace('s', 10000000))
        : service.id
)

export const projectServicesByProjectId = state => id =>
    _.filter(state.projectServices.items, {
        project_id: id ? parseInt(id) : null
    })

export const activeProjectServicesByProjectId = (state, getters) => id =>
    _.filter(getters.projectServicesByProjectId(id), service => service.status !== 'dropped')

export const projectServicesExceptOfOptionalByProjectId = state => id => {
    id = id ? parseInt(id) : null

    const projectServices = _.filter(state.projectServices.items, projectService =>
        projectService.project_id == id && projectService.type !== 'optional'
    )

    return sortAddedServices(projectServices)
}

export const projectServiceNameById = state => id => {
    let item = _.find(state.projectServices.items, { id: parseInt(id) })

    return item ? item.title : ''
}

export const projectServiceById = state => id =>
    _.find(state.projectServices.items, { id: parseInt(id) })

export const projectServicesBySource = state => ({source_id, source_type}) =>{
    // console.log(state.projectServices.items)
    return _.filter(state.projectServices.items, { source_id, source_type })
}

export const projectInitialServicesBySource = state => ({ source_type, source_id }) =>{
    // console.log(projectServicesBySource(state)({ source_type, source_id }), { source_type, source_id })
    return _.filter(projectServicesBySource(state)({ source_type, source_id }), { type: 'initial' })
}

export const projectOptionalServicesBySource = state => ({ source_id, source_type }) =>
    _.filter(projectServicesBySource(state)({ source_type, source_id }), { type: 'optional' })

export const projectServicesWhere = state => params =>
    _.filter(state.projectServices.items, params)

export const projectServicesQuantityByProjectId = (state, getters) => id => {
    let services = getters.activeProjectServicesByProjectId(id)

    return _.reduce(services, res => res + 1, 0) // quantity to be discussed
}

export const projectServicesTotalCostByProjectId = (state, getters) => id => {
    let services = getters.activeProjectServicesByProjectId(id)

    return _.reduce(services, (res, service) => res + service.final_price, 0)
}

export const projectServicesPaymentsByProjectId = (state, getters) => id => {
    let services = getters.activeProjectServicesByProjectId(id)

    return _.reduce(services, (res, service) => {
        return res + (service.status === 'paid' ? service.final_price : 0)
    }, 0)
}

export const contractPriceByProjectId = (state, getters) => id => {
    let services = getters.activeProjectServicesByProjectId(id)

    return _.reduce(services, (res, service) => {
        return res + (service.source === 'service' && service.type === 'initial' ? service.final_price : 0)
    }, 0)
}

export const changeOrdersPriceByProjectId = (state, getters) => id => {
    let services = getters.activeProjectServicesByProjectId(id)

    return _.reduce(services, (res, service) => {
        return res + (service.source === 'change-order' ? service.final_price : 0)
    }, 0)
}

export const expensesByProjectId = (state, getters) => id => {
    let services = getters.activeProjectServicesByProjectId(id)

    return _.reduce(services, (res, service) => {
        return res + ((service.source === 'custom' || service.reimbursable) ? service.final_price : 0)
    }, 0)
}
